import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {useFormicForm} from 'TemplateEditor/Layout/Blocks'
import {CodeConfigType} from 'TemplateEditor/Layout/Blocks/Code/Code'
import {TextAreaInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/TextAreaInput'
import {DefaultBlockConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockConfig'
import {DefaultBlockTopConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockTopConfig'
import {TEMPLATE_EDITOR_ACTIVE_FORM_ID} from 'TemplateEditor/templateEditorFormId'

export function CodeConfig() {
  const {t} = useI18n()
  const {handleSubmit, values, setFieldValue} = useFormicForm<CodeConfigType>()

  return (
    <>
      <form id={TEMPLATE_EDITOR_ACTIVE_FORM_ID} onSubmit={handleSubmit}>
        <DefaultBlockTopConfig values={values} setFieldValue={setFieldValue} />

        <TextAreaInput
          value={values.value}
          name={'value'}
          label={t('templateEditor.blockCode')}
          setFieldValue={setFieldValue}
        />

        <DefaultBlockConfig values={values} setFieldValue={setFieldValue} />
      </form>
    </>
  )
}
